import React, {useEffect, useState} from 'react';
import {Card, Layout, Progress} from 'antd';
import SideBar from "../Navbars/SideBar"
import NavBar from "../Navbars/NavBar";
import {MDBBox, MDBCardHeader, MDBCol, MDBContainer, MDBRow} from "mdbreact";
import { MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem } from "mdbreact";
import { MDBBtn, MDBCard, MDBCardText } from 'mdbreact';
import {Text} from "react-font";
import Firebase from "../../Firebase";
import {useAuthState} from "react-firebase-hooks/auth";
import {useHistory} from "react-router-dom";
import {useListVals} from "react-firebase-hooks/database";
import Graph from "../Graphs/Graph";
import OutletsCreated from "../Graphs/OutletsCreated";
import ProductsSold from "../Graphs/ProductsSold";
import MostSalesUser from "../Graphs/MostSalesUser";
import MostSoldProduct from "../Graphs/MostSoldProduct";
import QuantitySold from "../Graphs/QuantitySold";
import {useCollection} from "react-firebase-hooks/firestore";


var dbRef = Firebase.database().ref("System/");
const { Content } = Layout;
const db = Firebase.firestore();
const Home = () => {

    const history = useHistory();
    const [checkedData, setCheckedData] = useState(true);

    const [users] = useCollection(
        db.collection('users'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [outlets] = useCollection(
        db.collection('outlets'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [sales] = useCollection(
        db.collection('sales'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [products] = useCollection(
        db.collection('products'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [tasks] = useCollection(
        db.collection('tasks'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [periodText, setPeriodText] = useState("Last 7 days");
    const [taskArray, setTaskArray] = useState([]);
    const [productArray, setProductArray] = useState([]);
    const [userArray, setUserArray] = useState([]);
    const [saleArray, setSaleArray] = useState([]);
    const [outletArray, setOutletArray] = useState([]);
    const callback = (data) => {
        setCheckedData(data);
    }

    useEffect(() => {
        var tempUseArray = [];
        var tempOutArray = [];
        var tempProdArray = [];
        var tempTaskArray = [];
        var tempSaleArray = [];
        if(users){
            users.docs.map((item) => {
                var user = item.data();
                tempUseArray.push(user);
            });
            setUserArray([...tempUseArray]);
        }

        if(outlets){
            outlets.docs.map((item) => {
                var outlet = item.data();
                tempOutArray.push(outlet);
            });
            setOutletArray([...tempOutArray]);
        }

        if(products){
            products.docs.map((item) => {
                var outlet = item.data();
                tempProdArray.push(outlet);
            });
            setProductArray([...tempProdArray]);
        }

        if(sales){
            sales.docs.map((item) => {
                var sale = item.data();
                tempSaleArray.push(sale);
            });
            setSaleArray([...tempSaleArray]);
        }

        if(tasks){
            tasks.docs.map((item) => {
                var task = item.data();
                tempTaskArray.push(task);
            });
            setTaskArray([...tempTaskArray]);
        }

    }, [outlets, products, sales, tasks, users])

    return(
        <>

            <Layout style={{width: "100vw"}}>
                <SideBar checked={checkedData}/>
                <Layout className="site-layout">
                    <NavBar token={"token"} checkBack={callback}/>
                    <Content
                        className="site-layout-background"
                        style={{ margin: '10px 16px 15px'}}
                    >

                        <MDBBox className="p-3">
                            <MDBRow>
                                <Card bordered={false} className="w-100 mr-2">
                                    <div className="text-left">
                                        <div className="d-block">
                                            <h5 className="font-weight-bold">
                                                <Text family='Nunito'>
                                                    Statistics
                                                </Text>
                                            </h5>
                                            <MDBCardText>
                                                <Text family='Nunito'>
                                                    An overview of system stats
                                                </Text>
                                            </MDBCardText>
                                            <hr/>
                                        </div>
                                        <div className="mt-4 py-1">
                                            <MDBRow>
                                                <MDBRow className="w-100">
                                                    <MDBCol>
                                                        <MDBCard color={"amber lighten-5"} className="m-2 p-3 w-100 amber-text" style={{ height: "8rem" }}>
                                                                <span>
                                                                    <Text family='Nunito'  className="font-weight-bolder">Users</Text>
                                                                </span>
                                                            <h2 className="font-weight-bolder">
                                                                <Text family='Alfa Slab One' className="amber-text font-weight-bolder">{userArray.length}</Text>
                                                            </h2>

                                                        </MDBCard>
                                                    </MDBCol>
                                                    <MDBCol>
                                                        <MDBCard color={"teal lighten-5"} className="m-2 p-3 w-100 teal-text" style={{height: "8rem" }}>
                                                            <span>
                                                                    <Text family='Nunito'  className="font-weight-bolder">Outlets</Text>
                                                                </span>
                                                            <h2 className="font-weight-bolder teal-text">
                                                                <Text family='Alfa Slab One'>{outletArray.length}</Text>
                                                            </h2>
                                                        </MDBCard>
                                                    </MDBCol>
                                                    <MDBCol>
                                                        <MDBCard color={"red lighten-5"} className="m-2 p-3 w-100 red-text" style={{ height: "8rem" }}>
                                                            <span>
                                                                    <Text family='Nunito' className="font-weight-bolder">Products</Text>
                                                                </span>
                                                            <h2 className="font-weight-bolder red-text">
                                                                <Text family='Alfa Slab One'>{productArray.length}</Text>
                                                            </h2>
                                                        </MDBCard>
                                                    </MDBCol>
                                                    <MDBCol>
                                                        <MDBCard color={"blue lighten-5"} className="m-2 p-3 w-100 blue-text" style={{ height: "8rem" }}>
                                                            <span>
                                                                    <Text family='Nunito'  className="font-weight-bolder">Tasks</Text>
                                                                </span>
                                                            <h2 className="font-weight-bolder blue-text">
                                                                <Text family='Alfa Slab One'><strong>{taskArray.length}</strong></Text>
                                                            </h2>
                                                        </MDBCard>
                                                    </MDBCol>
                                                    <MDBCol>
                                                        <MDBCard color={"orange lighten-5"} className="m-2 p-3 w-100 orange-text" style={{ height: "8rem" }}>
                                                            <span>
                                                                    <Text family='Nunito'  className="font-weight-bolder">Sales</Text>
                                                                </span>
                                                            <h2 className="font-weight-bolder orange-text">
                                                                <Text family='Alfa Slab One'><strong>{saleArray.length}</strong></Text>
                                                            </h2>
                                                        </MDBCard>
                                                    </MDBCol>
                                                </MDBRow>
                                            </MDBRow>
                                        </div>
                                    </div>

                                </Card>

                            </MDBRow>
                            <MDBRow>
                                <Card bordered={false} className="w-100 mt-3 mr-2">
                                    <MDBCol >
                                        <div className="py-2 mr-3">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className="d-block">
                                                        <h5 className="font-weight-bold">
                                                            <Text family='Nunito'>
                                                                Sales Metrics
                                                            </Text>
                                                        </h5>
                                                    </div>
                                                    {/*<img src={program} className="img-fluid float-left p-4 mt-2" width={220} height={220} alt="" />*/}
                                                </div>
                                                <div>
                                                    <MDBCard className="d-flex flex-row align-items-center">
                                                        <strong className="mx-2 text-uppercase grey-text">Time Frame : </strong>
                                                        <MDBDropdown size="sm" className="float-right">
                                                            <MDBDropdownToggle caret color="primary">
                                                                {periodText}
                                                            </MDBDropdownToggle>
                                                            <MDBDropdownMenu basic>
                                                                {["Last 7 days", "Last 30 days", "Last 3 Months"].map((item) => (
                                                                    <MDBDropdownItem onClick={()=>{setPeriodText(item)}}>{item}</MDBDropdownItem>
                                                                ))}
                                                            </MDBDropdownMenu>
                                                        </MDBDropdown>
                                                    </MDBCard>

                                                </div>

                                            </div>
                                            <hr/>
                                        </div>
                                    </MDBCol>

                                    <MDBRow>

                                        <MDBCol md={12}>
                                            <MDBRow className="w-100">
                                                <Card className="mt-2 w-100">
                                                    <MDBRow className="d-flex align-items-center">
                                                        <MDBCol>
                                                            <div className="d-block ml-3">
                                                                <h6 className="font-weight-bold">
                                                                    <Text family='Nunito'>
                                                                        Number of Outlets Created
                                                                    </Text>
                                                                </h6>
                                                            </div>
                                                            {/*<img src={program} className="img-fluid float-left p-4 mt-2" width={220} height={220} alt="" />*/}
                                                        </MDBCol>

                                                    </MDBRow>
                                                    <hr/>
                                                    <MDBRow>
                                                        <Card bordered={false} className="w-100 bg-white">
                                                            <OutletsCreated period={periodText}/>
                                                        </Card>

                                                    </MDBRow>

                                                </Card>
                                            </MDBRow>

                                        </MDBCol>
                                        <MDBCol md={6}>
                                            <MDBRow className="w-100">
                                                <Card className="mt-2 w-100">
                                                    <MDBRow>
                                                        <MDBCol>
                                                            <div className="d-block ml-3">
                                                                <h6 className="font-weight-bold">
                                                                    <Text family='Nunito'>
                                                                        Most Sold Product (Sales)
                                                                    </Text>
                                                                </h6>
                                                            </div>
                                                            {/*<img src={program} className="img-fluid float-left p-4 mt-2" width={220} height={220} alt="" />*/}
                                                        </MDBCol>

                                                    </MDBRow>
                                                    <hr/>
                                                    <MDBRow>
                                                        <Card bordered={false} className="w-100 bg-white">
                                                            <MostSoldProduct period={periodText}/>
                                                        </Card>

                                                    </MDBRow>

                                                </Card>
                                            </MDBRow>
                                        </MDBCol>
                                        <MDBCol md={6}>
                                            <MDBRow className="w-100">
                                                <Card className="mt-2 w-100">
                                                    <MDBRow>
                                                        <MDBCol>
                                                            <div className="d-block ml-3">
                                                                <h6 className="font-weight-bold">
                                                                    <Text family='Nunito'>
                                                                        Quantities Sold (Units)
                                                                    </Text>
                                                                </h6>
                                                            </div>
                                                            {/*<img src={program} className="img-fluid float-left p-4 mt-2" width={220} height={220} alt="" />*/}
                                                        </MDBCol>

                                                    </MDBRow>
                                                    <hr/>
                                                    <MDBRow>
                                                        <Card bordered={false} className="w-100 bg-white">
                                                            <QuantitySold period={periodText}/>
                                                        </Card>

                                                    </MDBRow>

                                                </Card>
                                            </MDBRow>
                                        </MDBCol>
                                        <MDBCol md={12}>
                                            <MDBRow className="w-100">
                                                <Card className="mt-2 w-100">
                                                    <MDBRow>
                                                        <MDBCol>
                                                            <div className="d-block ml-3">
                                                                <h6 className="font-weight-bold">
                                                                    <Text family='Nunito'>
                                                                        Employee Sales
                                                                    </Text>
                                                                </h6>
                                                            </div>
                                                            {/*<img src={program} className="img-fluid float-left p-4 mt-2" width={220} height={220} alt="" />*/}
                                                        </MDBCol>

                                                    </MDBRow>
                                                    <hr/>
                                                    <MDBRow>
                                                        <Card bordered={false} className="w-100 bg-white">
                                                            <MostSalesUser period={periodText}/>
                                                        </Card>

                                                    </MDBRow>

                                                </Card>
                                            </MDBRow>

                                        </MDBCol>
                                        <MDBCol md={12}>
                                            <MDBRow className="w-100">
                                                <Card className="mt-2 w-100">
                                                    <MDBRow>
                                                        <MDBCol>
                                                            <div className="d-block ml-3">
                                                                <h6 className="font-weight-bold">
                                                                    <Text family='Nunito'>
                                                                        Products Sold
                                                                    </Text>
                                                                </h6>
                                                            </div>
                                                            {/*<img src={program} className="img-fluid float-left p-4 mt-2" width={220} height={220} alt="" />*/}
                                                        </MDBCol>

                                                    </MDBRow>
                                                    <hr/>
                                                    <MDBRow>
                                                        <Card bordered={false} className="w-100 bg-white">
                                                            <ProductsSold period={periodText}/>
                                                        </Card>

                                                    </MDBRow>

                                                </Card>
                                            </MDBRow>

                                        </MDBCol>
                                    </MDBRow>

                                </Card>
                            </MDBRow>

                        </MDBBox>

                    </Content>
                </Layout>
            </Layout>
        </>
    )
}


export default Home;
